import React from 'react';
import bowser from 'bowser';

import { Transition } from 'react-transition-group';
import { TRANSITION_END } from '../../util/supportedEvents';
import {
  timeoutsShape,
  classNamesShape,
} from 'react-transition-group/utils/PropTypes';

import { states, stateClassNames } from './transitionStates';

export const UNMOUNTED = 'unmounted';

export default class BrorTransition extends React.Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...Transition.propTypes,
    timeout: timeoutsShape,
    classNames: classNamesShape,
  };

  state = {
    transitionState: states.exited,
  };

  _reflowAndSetState = (node, transitionState) => {
    // eslint-disable-next-line no-unused-expressions
    node && node.scrollTop;

    this.setState({
      transitionState,
    });
  };

  addEndListener = (node, _done) => {
    let timeout;

    function done(e) {
      if (timeout) {
        timeout = null;

        clearTimeout(timeout);

        _done();
      }
    }

    const duration = parseFloat(
      window.getComputedStyle(node).getPropertyValue('transition-duration')
    );

    timeout = setTimeout(done, duration > 0 ? duration * 1100 : 0);

    node.addEventListener(TRANSITION_END, done, false);
  };

  onEnter = (node, isAppearing) => {
    this._reflowAndSetState(node, states.enter);
  };

  onEntering = (node, isAppearing) => {
    this._reflowAndSetState(node, states.entering);
  };

  onEntered = (node, isAppearing) => {
    this._reflowAndSetState(node, states.entered);
  };

  onExit = (node, isAppearing) => {
    this._reflowAndSetState(node, states.exit);
  };

  onExiting = (node, isAppearing) => {
    this._reflowAndSetState(node, states.exiting);
  };

  onExited = (node, isAppearing) => {
    this._reflowAndSetState(node, states.exited);
  };

  render() {
    const { children, ...props } = this.props;

    // No transitions for IE!
    if (props.in && bowser.msie) {
      return <React.Fragment>{this.props.children}</React.Fragment>;
    }

    const child = React.Children.only(children);

    const { transitionState } = this.state;

    const childProps = {
      transitionState,
    };

    if (this.props.classNames) {
      const classNames = stateClassNames[transitionState]
        .map(state => this.props.classNames[state])
        .filter(Boolean);

      if (classNames.length) {
        childProps.className =
          (child.props.className || '') + classNames.join(' ');
      }
    }

    const clonedChild = React.cloneElement(child, childProps);

    delete props.classNames;

    return (
      <Transition
        {...props}
        appear
        mountOnEnter
        unmountOnExit
        addEndListener={this.addEndListener}
        onEnter={this.onEnter}
        onEntered={this.onEntered}
        onEntering={this.onEntering}
        onExit={this.onExit}
        onExiting={this.onExiting}
        onExited={this.onExited}
      >
        {clonedChild}
      </Transition>
    );
  }
}
